import "core-js/modules/es.array.concat.js";
import defaultSettings from '@/settings';
var title = defaultSettings.title || '后台管理';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }

  return "".concat(title);
}